<template>
  <div>
    <div class="d-inline-flex">
      <luci-btn-icon :config="addBrandBtnConfig" @callback="$router.push({ name: 'BrandCreate' })"></luci-btn-icon>
      <luci-btn-icon :config="refreshTableBtnConfig" @callback="getItems({ sortBy })"></luci-btn-icon>
    </div>

    <v-alert v-if="error" :value="true" color="error" icon="error" class="error-container">
      <span class="error-span luci-text white--text">{{ error }}</span>
    </v-alert>

    <luci-table :loading="isLoading || deleteLoading" :config="brandListConfig" @edit-row-callback="editBrand" @delete-row-callback="openDeleteModal" @sort-by-callback="sortCallback"></luci-table>
    <paging name="brand-list" :view="view" @page="gotoPage"></paging>

    <confirm-modal
      :open="showDeleteModal"
      @yes-callback="deleteBrand"
      @no-callback="closeDeleteModal"
      :title="'Delete brand?'"
      :message="'Do you want to delete brand: <b>'+ this.brandToDelete.name +'</b> ?'"
    ></confirm-modal>

    <message-modal :open="showMsgModal" @ok-callback="showMsgModal = false"></message-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { split } from 'lodash'

import ConfirmModal from '../modal/ConfirmModal'
import MessageModal from '../modal/MessageModal'
import Paging from '../shared/paging/Paging'
import variables from '../../helpers/variables'

export default {
  computed: {
    ...mapGetters({
      error: 'brand/list/error',
      items: 'brand/list/items',
      isLoading: 'brand/list/isLoading',
      view: 'brand/list/view',
      tableItems: 'brand/list/tableItems',
      deleteError: 'brand/del/error',
      deleteLoading: 'brand/del/isLoading'
    }),
    brandListConfig () {
      return {
        title: 'Brands',
        showSearch: true,
        items: this.tableItems,
        headers: [
          { text: 'Name', value: 'data.name', sortable: true },
          { text: 'Description', value: 'data.description' },
          { text: 'Actions', value: 'actions' }
        ],
        pagination: { sortBy: 'data.name' },
        serverSorting: true,
        showButtonEdit: true,
        showButtonDelete: true,
        hideActions: true
      }
    }
  },
  components: {
    ConfirmModal, MessageModal, Paging
  },
  data () {
    return {
      showMsgModal: false,
      showDeleteModal: false,
      brandToDelete: {},
      addBrandBtnConfig: {
        type: 'button',
        name: 'add-brand-btn',
        primary: true,
        icon: true,
        iconType: 'add',
        tooltip: 'Add a new brand'
      },
      refreshTableBtnConfig: variables.refreshBtnIconOptions,
      sortBy: null
    }
  },
  created () {
    this.getItems({ sortBy: this.sortBy })
  },
  methods: {
    ...mapActions({
      getItems: 'brand/list/getItems',
      delete: 'brand/del/del'
    }),
    editBrand (item) {
      this.$router.push({ name: 'BrandUpdate', params: { id: item['@id'] } })
    },
    openDeleteModal (item) {
      this.showDeleteModal = true
      this.brandToDelete = item
    },
    closeDeleteModal () {
      this.showDeleteModal = false
      this.brandToDelete = {}
    },
    deleteBrand () {
      this.showDeleteModal = false
      this.delete(this.brandToDelete).then(() => {
        if (!this.deleteError) {
          this.brandToDelete = {}
          this.getItems({ sortBy: this.sortBy })
        } else {
          this.showMsgModal = true
        }
      })
    },
    gotoPage (page) {
      this.getItems({ sortBy: this.sortBy, page: this.view['hydra:' + page] })
    },
    sortCallback (column, descending) {
      const field = split(column, '.')[1]
      const direction = descending ? 'desc' : 'asc'
      this.sortBy = `order[${field}]=${direction}`
      this.getItems({ sortBy: this.sortBy })
    }
  }
}
</script>
